<template>
    <div
        :class="['reo-vfx-area', { 'half-width': item.half }]" >
        <label class="reo-vfx-box">
            <input type="text"
                :class="['reo-vfx-input', { empty: item.value === '', error: item.error }]"
                :value="item.value"
                @change="changeValue"
                :autocomplete="item.autocomplete"
                @focus="hideError">
            <span class="reo-vfx-placeholder">{{ item.placeholder }}</span>
            <span v-if="item.required" class="reo-vfx-required-flag">*</span>
        </label>
        <p v-if='item.error' style='font-size:16px;color:red;margin-top:6px'>{{item.error}}</p>
    </div>
</template>

<script lang="ts">
import { IVFXBoxItem } from '@reolink-cloud/interface';
import Vue, { PropType } from 'vue';

export default Vue.extend({
    model: {
        prop: 'item',
        event: 'change'
    },
    props: {
        item: Object as PropType<IVFXBoxItem>
    },
    methods:{
        changeValue( e: Event ) {

            const value = ( e.target as HTMLInputElement ).value.trim();
            this.$emit( 'change', { ...this.item, value });

        },
        hideError() {

            this.$emit( 'change', { ...this.item, error: false });

        }
    }
});
</script>

<style lang="less" scoped>
.reo-vfx-area {
    display: inline-block;
    width: 100%;
    margin-bottom: 20px;

    &.half-width {
        width: calc((100% - 20px) / 2);

        &:nth-child(even) {
            margin-left: 20px;
        }
    }

    .reo-vfx-box {
        position: relative;
        display: block;
    }

    .reo-vfx-input {
        font-weight: 500;
        font-size: 16px;
        padding: 0 20px;
        width: 100%;
        height: 48px;
        line-height: 48px;
        box-sizing: border-box;
        box-shadow: none;
        outline: none;
        border: 1px solid transparent;
        border-radius: 6px;
        box-shadow: 0 0 6px 2px rgba(0,0,0,.14);

        @media @snapeak_mobile {
            font-size: .28rem;
        }

        &:focus {
            background-color: transparent;
            border-color: @brand_light;
        }

        &.error {
            border-color: @error;
        }

    }

    .reo-vfx-placeholder {
        white-space: nowrap;
        transition: all 0.3s ease-in-out;
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        pointer-events: none;
        font-size: 16px;
        font-weight: 500;
        display: inline-block;
        padding: 0 4px;
        color: @font_secondary;

        @media @snapeak_mobile {
            font-size: .28rem;
        }
    }

    .reo-vfx-input:focus~.reo-vfx-placeholder,
    .reo-vfx-input:not(.empty)~.reo-vfx-placeholder {
        top: 0;
        font-size: 14px;
        color: @brand_lightest;
        background-color: @bg_02;

        @media @snapeak_mobile {
            font-size: .24rem;
        }
    }

    .reo-vfx-input:focus~.reo-vfx-placeholder {
        color: @brand_lightest;
    }

    .reo-vfx-required-flag {
        position: absolute;
        top: 0;
        right: -10px;
        color: #e74330;
        font-weight: 500;
        font-size: 18px;
    }

    .input-tip {
        font-size: 14px;
        color: #777;
        font-weight: 500;
        line-height: 1.2;
        margin-top: 16px;
    }
}

@media @snapeak_mobile {
    .reo-vfx-area.half-width[name="postalCode"] {
        margin-left: 0;
        width: 100%;
    }
}
</style>
